import { ColumnConfig } from "grommet";
import React from "react";
import { RoleType } from "../types/RoleType";
import roleEditIcon from "../../../../../../../assets/edit.png"
import { RootStore } from "../../../../../../../store/RootStore";
import EditRolesBar from "../EditRolesBar";
import { UserType } from "../../Users/types/UserType";
import EditProfile from "../../EditProfile/EditProfile";
import { EditProfileStore } from "../../../../../../../store/EditProfileStore";


export const RoleTableColumns: ColumnConfig<RoleType>[] = [
  {
    property: "code",
    header: "Role Name",
    primary: true,
    render: (item) => {
      return <div className="cell-container">{item.code}</div>;
    },
  },
  {
    property: "displayName",
    header: "Description",
    primary: true,
    render: (item) => {
      return <div className="cell-container">{item.displayName}</div>;
    },
  },
  {
    property: "isStandard",
    header: "Role Type",
    primary: true,
    render: (item) => {
      return (
        <div className="cell-container">
          {item.isStandard ? "Standard" : "User Defined"}
        </div>
      );
    },
  },
];
